import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getQuizTestsLeaderboard,
  getQuizTestsList,
  getQuizTestCertificates,
} from "../../../actions/operations.js";

import { useState } from "react";
import DashboardSections from "./DashboardSections.jsx";

const Dashboard = () => {
  const dispatch = useDispatch();

  //Get leaderboard data from Redux store
  const { quizTestsLeaderboard } =
    useSelector(({ quizTest }) => quizTest) || {};

  //Local state to handle loading and stats
  const [leaderboardLoading, setLeaderboardLoading] = useState(true);
  const [pendingQuizzes, setPendingQuizzes] = useState(null);
  const [publicQuizzes, setPublicQuizzes] = useState(null);
  const [stats, setStats] = useState({
    completedTestsCount: 0,
    totalFailed: 0,
    totalPassed: 0,
  });
  const [totalcertificates, setTotalcertificates] = useState(0);

  //Get user details from localStorage
  const testUser = JSON.parse(localStorage.getItem("userDetails"));
  console.log("Logged in user:", testUser);
  
  useEffect(() => {
    dispatch(getQuizTestsLeaderboard()).then((res) => {
      console.log("leaderboard", res);
      console.log("Leaderboard first entry:", res?.data?.[0]);

      
      if (res?.success && Array.isArray(res?.data)) {
        const currentUserData = res?.data?.find(
          (user) => user.userId === testUser?._id
        );
 
      console.log("Current user data in leaderboard:", currentUserData);
      if (currentUserData) {
        setStats({
          completedTestsCount: currentUserData?.quizzesAttempted,
          totalFailed: res.totalFailed,
          totalPassed: res.totalPassed,
          totalScore: currentUserData.totalScore,
          rank: currentUserData.globalRank,
        });
      } else {
        console.warn("User not found in leaderboard!");
        setStats({
          completedTestsCount: currentUserData?.quizzesAttempted,
          totalPassed: res.totalPassed,
          totalFailed: res.totalFailed,
          totalScore: 0,
          rank: "-",
        });
      }
      setLeaderboardLoading(false);
    }
  });

    dispatch(getQuizTestsList()).then((res) => {
      console.log("quiz list", res);
      // filter here itself
      if (res?.data && Array.isArray(res.data)) {
        const pending = res.data.filter(
          (quiz) => quiz.inviteStatus === "pending"
        );
        setPendingQuizzes(pending);
      }
    });

    // Fetch public quizzes
    dispatch(getQuizTestsList()).then((res) => {
      if (res?.data && Array.isArray(res.data)) { 
        const publicQz = res.data.filter(
          (quiz) => quiz.access === "public"
        );
        setPublicQuizzes(publicQz);
      }
    });

    dispatch(getQuizTestCertificates()).then((res) => {
      console.log("certificates data", res);
      if (res?.success) {
        setTotalcertificates(res.data);
  }
    });

  }, [dispatch,testUser?._id]);

  return (
    <>
      <div className="container-fluid px-0 mt-0 quiz-board">
        <div className="row mx-0 px-0 pt-5 quiz-main-section">
          <DashboardSections
            quizTestsLeaderboard={quizTestsLeaderboard}
            leaderboardLoading={leaderboardLoading}
            quizTestsList={pendingQuizzes} // only pending ones
            publicQuizzes={publicQuizzes}
            stats={stats}
            totalcertificates={totalcertificates}
            currentUser={testUser}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
